import { Component, Input } from '@angular/core';

@Component({
    selector: 'project-team-invites',
    template: require('./project.team.invites.component.html'),
})
export class ProjectTeamInvitesComponent {

    @Input() parentCtrl: any = null;

    constructor(
    ) { }
}